import { render } from "./EmpresaView.vue?vue&type=template&id=207df1a2"
import script from "./EmpresaView.vue?vue&type=script&lang=js"
export * from "./EmpresaView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__